/**
 * Time is a dependency, not a system call (.claude/rules/conventions.md,
 * ADR 0001).
 *
 * Mirrors `apps/participant/src/lib/clock.ts` on purpose: this is the single
 * place in the backoffice that reads the system time. Every deadline that is
 * actually binding is decided by the SERVER in the time zone of the action;
 * what the backoffice does with a clock is preview and display, never
 * authority.
 */
export interface Clock {
  now(): Date;
}

export const systemClock: Clock = {
  now: () => new Date(),
};

/** Fixed clock for tests and for a reproducible preview. */
export function fixedClock(instant: Date): Clock {
  return { now: () => new Date(instant.getTime()) };
}
